module.exports = __webpack_public_path__ + "img/kachel-STRESS_REISHI.a81d19b2.png";